import { render } from "./SegregationCashTable.vue?vue&type=template&id=aecda382&ts=true"
import script from "./SegregationCashTable.vue?vue&type=script&lang=ts"
export * from "./SegregationCashTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__